export const updateEmbedUrl = (embedUrl) => {
  return {
    type: "UPDATE_EMBED_URL",
    payload: { embedUrl }
  }
};
